import { Analytics } from '@repo/analytics/src/Analytics';

export const analytics = new Analytics(process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY);
